import ButtonSendChatHistory from './ButtonSendChatHistory';

export default ButtonSendChatHistory;